
export class LoginModel {
  public email: string;
  public password: string;
}

export class NewPasswordModel {
  public confirmHash: string;
  public newPassword: string;
  public confirmPassword: string;
}

export class EmailModel {
  public email: string;
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/authorization/login.model.ts